<template>
<v-container fluid class="grey lighten-5" id="about">
      <v-row class="text-center px4">
        <v-col col="12">
          <h1 class="font-weight-bold text-h4 mb--1 pa-12">
            NUESTROS CLIENTES</h1>
        </v-col>
      </v-row>
<!--  <v-sheet
    class="mx-auto"
    elevation="8"
    max-width="800"
  >
    <v-slide-group
     v-model="model"
      class="pa-4"
      show-arrows
    >
      <v-slide-item
        v-for="(item,i) in clients"
        :key="i"
      >
      <v-card
          class="ma-6"
          height="auto"
          width="auto"
        >
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-scale-transition>
              <v-img
              max-height="auto"
              max-width="300"
              :src="item.img"
            ></v-img>
            </v-scale-transition>
          </v-row>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-sheet> -->

<!-- Version 2 funcionando
  <v-sheet
    class="mx-auto"
    max-width="800"
  >
    <v-slide-group
      v-model="model"
      class="pa-4"
      active-class="success"
      show-arrows
    >
      <v-slide-item
        v-for="(item,i) in clients"
        :key="i"
      >
        <v-card
          class="ma-6"
          height="100"
          width="100"
        >
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-scale-transition>
              <v-img
              max-height="auto"
              max-width="auto"
              :src="item.img"
            ></v-img>
            </v-scale-transition>
          </v-row>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-sheet> -->

  <hooper :settings="hooperSettings">
    <slide
    v-for="(item,i) in clients"
    :key="i">
      <v-img
        max-height="200"
        max-width="200"
        :src="item.img"
      ></v-img>
    </slide>
  <hooper-navigation slot="hooper-addons"></hooper-navigation>
  </hooper>
  </v-container>
</template>

<script>
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation
} from 'hooper'
import 'hooper/dist/hooper.css'
import axios from 'axios'
const BASE_URL = 'https://innuvex.com/'

export default {
  name: 'Clients',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  data () {
    return {
      clients: [],
      model: null,
      hooperSettings: {
        itemsToShow: 4,
        autoPlay: true,
        playSpeed: 3000,
        infiniteScroll: true,
        centerMode: true,
        breakpoints: {
          320: {
            itemsToShow: 1,
            pagination: 'fraction'
          },
          600: {
            itemsToShow: 3,
            pagination: 'fraction'
          },
          1000: {
            itemsToShow: 6,
            pagination: 'fraction'
          }

        }
      }
    }
  },
  mounted () {
    // axios.get(BASE_URL + 'api/client/').then((response) => { console.log(response.data) })
    this.getClient()
    console.log(this.getClient())
    // console.log(this.getImageBlob())
  },
  methods: {
    getClient () {
      var self = this
      axios({
        method: 'GET',
        url: BASE_URL + 'apiv1/client/'
      }).then((response) => {
        self.clients = response.data.map((key) => {
          return {
            id: key.id,
            cliente: key.client_name,
            description: key.description,
            img: key.image
          }
        })
      }).catch((e) => {
        console.error(e)
      })
    }
  }
}

</script>
